import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cb835334"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { id: "mol-viewer" }, null, -1));
const _hoisted_2 = [
    _hoisted_1
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", {
        class: _normalizeClass(_ctx.containerClass),
        onMousemove: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args)))
    }, _hoisted_2, 34));
}
